import { render, staticRenderFns } from "./examImageEditor.vue?vue&type=template&id=3987e3ea"
import script from "./examImageEditor.vue?vue&type=script&lang=js"
export * from "./examImageEditor.vue?vue&type=script&lang=js"
import style0 from "./examImageEditor.vue?vue&type=style&index=0&id=3987e3ea&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports